<template lang="pug">
  .height-100
    .modal.is-active(
      v-if="mostrarModalAsignarEmpleado"
      :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
    )
      .modal-background(@click="mostrarModalAsignarEmpleado = false")
      transition(name='fade-quick')
        seleccionar-empleado(
          :fetchEndpoint="fetchEndpoint"
          :filtroProp="filtroAsignarEmpleado"
          :asignarEmpleadosEndpoint="asignarEmpleadosEndpoint"
          :desasignarTodosEndpoint="desasignarTodosEndpoint"
          :asignarTodosEndpoint="asignarTodosEndpoint"
          :objAux="objAux"
          @close="closeModalAsignarEmpleado()"
        )
    .title.pt-5
      span Alumnos
    .text-center
      button.button.is-small.is-primary.mb-5(@click="abrirModalAsignarEmpleados()")
        span.icon.is-small
          i.fa.fa-users.is-small
        span Asignar
    .body
      .data
        transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
          .usuario(
            v-for="(o, index) in lista"
            :key="'alumno_' + index"
            @dblclick="abrirModalAsignarEmpleados(o.dni)"
          )
            .display-flex.fdr
              span.flex {{ o.nombre }}
        div(v-if="lista.length === 0" key="message_warning")
          .message.is-warning
            .message-body No hay alumnos registrados
        .is-loading(v-if="isLoading" key="loading_spin")
          .icon
            i.fa.fa-spinner.fa-spin

</template>

<script>
import ComponentConfirmarAccionOverlay from './Component_Confirmar_Accion_Overlay';
import SeleccionarEmpleado from './lookups/Empleados_Multiple';
import { apiGet, notify } from '../util/general'
export default {
  name: 'c_alumnos_lista',
  data () {
    return {
      lista                           : [],
      isLoading                       : false,
      isSendingEliminar               : false,
      disabledScrollExecute           : true,
      mostrarModalAsignarEmpleado     : false,
      skip                            : 0,
      noMore                          : false,
      filtroAsignarEmpleado           : '',
      objAux                          : { idCurso: this.idCurso }
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idCurso () {
      return +this.$route.params.id
    },
    idClase () {
      return +this.$route.params.idClase
    },
    baseEP () {
      return '/curso/gestion/' + this.idCurso
    },
    fetchEndpoint () {
      return this.baseEP + '/alumno/asignar'
    },
    asignarEmpleadosEndpoint () {
      return this.baseEP + '/alumno/asignar'
    },
    asignarTodosEndpoint () {
      return this.baseEP + '/alumno/asignar/todos'
    },
    desasignarTodosEndpoint () {
      return this.baseEP + '/alumno/desasignar/todos'
    }
  },
  components: {
    'confirmar-accion-overlay' : ComponentConfirmarAccionOverlay,
    'seleccionar-empleado':SeleccionarEmpleado
  },
  created () {
  },
  mounted () {
    var vm = this
    if (vm.idCurso) {
      vm.fetch()
    }
  },
  methods: {
    closeModalAsignarEmpleado () {
      this.mostrarModalAsignarEmpleado = false
      this.fetch()
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      var obj = {}
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, vm.baseEP + '/alumno', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip = data.numeroRecnum
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExecute = true
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    abrirModalAsignarEmpleados (dni) {
      var vm = this
      if (!vm.idCurso) {
        vm.$emit('save')
        return
      }
      vm.filtroAsignarEmpleado = dni
      this.mostrarModalAsignarEmpleado = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .data
    max-height 250px
    overflow-y auto
    scrollbar-width: none; /* Firefox */
    padding 2px
    &::-webkit-scrollbar
      display none // Ocultar barra en Chrome, Safari y navegadores Webkit
    .usuario
      background #fff
      border-radius 3px
      border 1px solid #d6dadc
      border-bottom-color #c4c9cc
      -webkit-box-shadow 0 1px 6px rgba(0,0,0,.15)
      box-shadow 0 1px 6px rgba(0,0,0,.15)
      padding 10px
      margin-bottom 5px
      cursor pointer
      transition all .2s ease
      width 100%
      max-width: 290px
      &:hover
        background-color #edeff0
        margin-left 4px
        -webkit-box-shadow -8px 0 #959da17d
        box-shadow -8px 0 #959da17d
      span.italic
        text-align left
      .contenedor-acciones
        padding-left 1em
    .contenedor-box
      >*
        transition all .5s
        width 100%
  .is-mobile
    .is-close
      background-color #ffd6d6 !important
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      // span
      //   font-weight bold
      //   text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display block
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  // @media (max-width 400px)
  //   .is-mobile
  //     display block

  //   .is-desktop
  //     display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 500px)
    .data
      .usuario
        width: 100%;
        max-width: 100%;
        min-width: 100%;
</style>




// WEBPACK FOOTER //
// c_alumnos_lista.vue?440f863c